import { render, staticRenderFns } from "./workorder-view.vue?vue&type=template&id=ce5f4828&scoped=true"
import script from "./workorder-view.vue?vue&type=script&lang=js"
export * from "./workorder-view.vue?vue&type=script&lang=js"
import style0 from "./workorder-view.vue?vue&type=style&index=0&id=ce5f4828&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5f4828",
  null
  
)

export default component.exports